import { AttributeAPI } from "@griffingroupglobal/eslib-api";
import sortByProperty from "../../../../helpers/Utilities/sortByProperty";

const fetchAttributesHandler = async (signal) => {
  const response = await AttributeAPI.get({ signal });
  const attributesArray = response?.data?.entries?.map((item) => {
    return {
      ...item?.resource,
      detail: item?.resource?.detail?.toLowerCase(),
    };
  });
  const sortedArray =
    attributesArray?.length > 0
      ? sortByProperty(attributesArray, "detail")
      : [];
  return sortedArray;
};

export default fetchAttributesHandler;
